import React, { Component, Fragmant } from 'react';

import logo from './logo.svg';
import './App.css';
import Socials from './components/Socials';
import Copyright from './components/Copyright';
import Slider from './components/Slider';

class App extends Component {
  render() {
     return (
      <>
        <Socials></Socials>
        <Slider></Slider>
        <Copyright></Copyright>
      </>
    );
  }
}


export default App;
